/// <amd-module name="Test/TestPlansHubRefresh/TestPlansHubRefreshFilter/TestPlansHubRefreshFilterComponent" />
import * as React from "react";
import {
    ITestPlansHubFilterItem,
    ITestPlansHubRefreshFilterComponentProps,
    TestPlansHubFilterItemType
} from "TestPlansHubRefreshFilterComponent.Types";
import { IObservableValue } from "VSS/Core/Observable";
import { VssComponent } from "VSS/Platform/Layout";
import { DropdownFilterBarItem } from "VSSUI/Dropdown";
import { FilterBar } from "VSSUI/FilterBar";
import { Observer } from "VSSUI/Observer";
import { KeywordFilterBarItem } from "VSSUI/TextFilterBarItem";
import { FilterContext, IFilter } from "VSSUI/Utilities/Filter";

export class TestPlansHubRefreshFilterComponent extends React.Component<ITestPlansHubRefreshFilterComponentProps> {
    public render(): JSX.Element {
        return (
            <FilterContext.Consumer>
                {(value: { filter: IFilter; filterToggled: IObservableValue<boolean> }) => (
                    <Observer value={value.filterToggled}>
                        {() => {
                            return value.filterToggled.value ? (
                                <FilterBar className={this.props.className} filter={value.filter}>
                                    {this._renderFilterFields(value.filter)}
                                </FilterBar>
                            ) : null;
                        }}
                    </Observer>
                )}
            </FilterContext.Consumer>
        );
    }

    private _renderFilterFields(filter: IFilter): JSX.Element[] {
        const filterBarItemsToRender: JSX.Element[] = [];
        if (this.props.filterBarItems && this.props.filterBarItems.length > 0) {
            for (const filterBarItem of this.props.filterBarItems) {
                const filterItemToRender: JSX.Element = this._getFilterItemToRender(filterBarItem, filter);
                filterBarItemsToRender.push(filterItemToRender);
            }
        }

        return filterBarItemsToRender;
    }

    private _getFilterItemToRender(filterBarItemProps: ITestPlansHubFilterItem, filter: IFilter): JSX.Element {
        let filterBarItemToRender: JSX.Element = <></>;
        if (filterBarItemProps) {
            switch (filterBarItemProps.filterItemType) {
                case TestPlansHubFilterItemType.TextFilter:
                    filterBarItemToRender = (
                        <KeywordFilterBarItem
                            key={filterBarItemProps.key}
                            filter={filter}
                            filterItemKey={filterBarItemProps.filterItemKey}
                            placeholder={filterBarItemProps.placeholder}
                        />
                    );
                    break;

                case TestPlansHubFilterItemType.DropDownFilter:
                    filterBarItemToRender = (
                        <DropdownFilterBarItem
                            key={filterBarItemProps.key}
                            filter={filter}
                            filterItemKey={filterBarItemProps.filterItemKey}
                            placeholder={filterBarItemProps.placeholder}
                            selection={filterBarItemProps.selection}
                            items={filterBarItemProps.items}
                            width={filterBarItemProps.width}
                        />
                    );
                    break;
            }
        }

        return filterBarItemToRender;
    }
}

VssComponent.register("testplans-hub-refresh-filter-component", TestPlansHubRefreshFilterComponent);
